import { styled, Typography } from "@material-ui/core";
import { differenceInYears, format } from "date-fns";
import type { Gender } from "elephant-web/gql";
import { FormattedMessage } from "react-intl";

const Container = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: 4,
});

const Name = styled(Typography)({
  fontSize: 24,
  fontWeight: 700,
});

const AgeAndSexContainer = styled("div")({
  display: "flex",
  gap: 16,
});

const AgeAndSexText = styled(Typography)({
  fontSize: 14,
  fontWeight: 400,
});

export const BasicDetails: React.FC<{
  name: string;
  dob: Date;
  sex: Gender;
}> = ({ name, dob, sex }) => {
  const age = differenceInYears(new Date(), dob);
  return (
    <Container>
      <Name>{name}</Name>
      <AgeAndSexContainer>
        <AgeAndSexText>
          <FormattedMessage
            id="patientCentre.basicDetails.dob"
            defaultMessage="DOB: <b>{dob} (age {age})</b>"
            values={{
              dob: format(dob, "dd MMM yyyy"),
              age,
              b: (chunks) => <strong>{chunks}</strong>,
            }}
          />
        </AgeAndSexText>
        <AgeAndSexText>
          <FormattedMessage
            id="patientCentre.basicDetails.sex"
            defaultMessage="Sex: <b>{sex}</b>"
            values={{
              sex: sex.charAt(0).toUpperCase() + sex.slice(1).toLowerCase(),
              b: (chunks) => <strong>{chunks}</strong>,
            }}
          />
        </AgeAndSexText>
      </AgeAndSexContainer>
    </Container>
  );
};
